import { Button } from "react-bootstrap";
import React, { useState } from "react";
import Download from "@/components/icons/Download";
import { useTranslation } from "react-i18next";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import * as htmlToImage from "html-to-image";
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from "html-to-image";
import { useAuth } from "@/services/Auth";
import axios from "axios";
import LOCATION from "@/constants/Location";
import LoaderOverlay from "@/components/LoadingOverlay";
function DownloadButton({
    element,
    fileName,
    width,
    height,
    orientation,
    multiplePages,
    scale,
    ...params
}) {
    const { t } = useTranslation();
    const auth = useAuth();
    const [loadingOverlay, setLoadingOverlay] = useState(false);
    let token = localStorage.getItem("token") || null;
    let accreditationLogo = "/assets/images/headeroriginal.png";

    // Define the PDF settings, such as page size
    const pageWidth = 210;
    const pageHeight = 297;
    const margin = 10;

    // Define the width and height for the images
    const imageWidth = pageWidth - 2 * margin;
    const imageHeight = pageHeight - 2 * margin;
    //console.log("params", params.downloadURL);
    const downloadPDF = () => {
        if (params.downloadURL) {
            const link = document.createElement('a');
            link.href = params.downloadURL;
            link.setAttribute('download', fileName+'.pdf'); // Set the download attribute with a filename
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            return true;
        } else {
            console.log('Download URL is not provided.');
        }

        const doc = new jsPDF({
            format: "a4",
            unit: "px",
            orientation: orientation ?? "p",
        });

        multiplePages ? loadMultiplePages(doc) : loadSinglePage(doc);
        //const elementsToConvert = document.querySelectorAll('#assessment-certificate');
        //addImagesToPDF(elementsToConvert);
    };

    /*  const addImagesToPDF = (elements) => {
        alert("in ");
        elements.forEach((element, index) => {
          if (index > 0) {
            addPage(); // Add a new page for each image after the first one
          }

          htmlToImage
            .toPng(element)
            .then(function (dataUrl) {
              let img = new Image();
              img.src = dataUrl;

              // Calculate the position of the image on the page
              const x = margin;
              const y = margin;

              doc.addImage(img, 'PNG', x, y, imageWidth, imageHeight);

              if (index === elements.length - 1) {
                // If it's the last image, save the PDF
                doc.save('multi-page-pdf.pdf');
              }
            })
            .catch(function (error) {
              console.error(error);
            });
        });
      }
      const doc = new jsPDF();
      const addPage = () => {
        doc.addPage();
      } */

    /* const testLkey = () => {
        auth.getRequest(`${LOCATION.LICENSE_KEY.API.path}`, [],{
            timeout: 100000,
        }) // Updated endpoint
            .then((response) => {
                console.log(" Response testLkey ", response);

                setLoadingOverlay(false);
            })
            .catch((error) => {
                // Handle error
            });
    }; */
    const loadSinglePage = (doc) => {
        const elems = [element];
        //const responseUploadPdf = testLkey();return false;
        /* elems.forEach((elem, ind) => {
            const node = document.querySelector(elem);
            htmlToImage
                .toPng(node)
                .then(function (dataUrl) {
                    let img = new Image();
                    img.src = dataUrl;

                    doc.addImage(img, "png", 0, 0, width, height);

                    doc.save(fileName);
                })
                .catch(function (error) {
                    // console.log(error)
                });
        }); */

        elems.forEach((elem, ind) => {
            let footerText = "Powered by FRA Wizard.";
            if (params.pdfWatermark) {
                if (params.pdfWatermark.banner !== "") {
                    accreditationLogo = params.pdfWatermark.banner;
                }
                if (params.pdfWatermark.title !== "") {
                    footerText = "Powered by " + params.pdfWatermark.title;
                }
            }
            const node = document.querySelector(elem);
            console.log("url('" + accreditationLogo + "')");
            // url('data:image/png;base64,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')
            /*  const header = document.createElement("div");
            header.id = "custom-header";
            header.style.backgroundImage = "url('" + accreditationLogo + "')";
            header.style.backgroundSize = "100% auto";
            header.style.backgroundRepeat = "no-repeat";

            header.style.width = "100%";
            header.style.height = "200px";
            //header.style.backgroundPosition = "0px -5px"; // customize header background color
            header.style.marginTop = "0px";
            header.style.fontFamily = "arial,sans-serif";
            //header.innerText = "Custom Header"; // replace with your header content
            node.insertBefore(header, node.firstChild); */

            const footerContainer = document.createElement("div"); // Custom div for the footer
            footerContainer.id = "custom-footer-container";
            node.appendChild(footerContainer);

            const footer = document.createElement("div");
            footer.id = "custom-footer";
            footer.style.textAlign = "center";
            footer.style.backgroundColor = "#cfd4da"; // customize footer background color
            footer.style.width = "100%";
            footer.style.height = "50px"; // adjust height as needed
            footer.style.paddingTop = "20px";
            //footer.style.fontFamily = "arial,sans-serif";
            //footer.style.marginLeft = "-30px;";
            //footer.style.marginRight = "-30px;";
            footer.style.color = "#000";

            footer.innerText = footerText; //"Powered by FRA Wizard."; // replace with your footer content
            //node.appendChild(footer);
            //footerContainer.appendChild(footer);

            htmlToImage
                .toPng(node)
                .then(function (dataUrl) {
                    let img = new Image();
                    img.src = dataUrl;

                    doc.addImage(img, "png", 0, 0, width, height);

                    doc.save(fileName);
                    //var divToRemove = document.getElementById("custom-header");
                    //if (header) {
                    // header.parentNode.removeChild(header);
                    //}
                    if (footer) {
                        //footer.parentNode.removeChild(footer);
                    }
                })
                .catch(function (error) {
                    // console.log(error)
                });

            // Create a style element and add your custom CSS

            /* const styleElement = document.createElement("style");
            styleElement.type = "text/css";

            // Define your CSS rules here
            const customCSS = `
            .custom-table {
                border-collapse: collapse;
                width: 100%;
            }

            .custom-table td {
                border: 1px solid #ccc;
                padding: 8px;
                text-align: center;
            }
            .custom-table tr:nth-child(6n+4) td,.custom-table tr:nth-child(6n+5) td {
                clear: both;
                display: block;
                width: 100%;
            }

            .td-css-custome
            {
                width: 33.33% !important;
                float: left !important;
            }


            .custome-alignment
            {
                display: flex;
                justify-content: end;
            }

            * {
                box-sizing: border-box;
                padding: 0;
                margin: 0
            }

            .progress {
                width: 40px;
                height: 40px;
                font-size: 14px;
                color: #000;
                border-radius: 50%;
                overflow: hidden;
                position: relative;
                background: #fff;
                text-align: center;
                line-height: 40px;
                margin: 0px;
                font-weight: bold;
                justify-content: center;
            }

            .progress .title {position: relative;z-index: 100;}

            .progress .overlay {
                width: 50%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 1;
                background-color: #fff;
            }

            .progress .left, .progress .right {
                width: 50%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                border: 4px solid rgba(40,167,69,0.85);
                border-radius: 100px 0px 0px 100px;
                border-right: 0;
                transform-origin: right;
            }


            .progress .left {animation: load1 1s linear forwards;}

            .progress:nth-of-type(2) .right, .progress:nth-of-type(3) .right {animation: load2 .5s linear forwards 1s;}

            .progress:last-of-type .right, .progress:first-of-type .right {animation: load3 .8s linear forwards 1s;}

            @keyframes load1 {
                0% {transform: rotate(0deg);}

                100% {transform: rotate(180deg);}
            }

            @keyframes load3 {
                0% {z-index: 100;transform: rotate(180deg);}

                100% {
                    z-index: 100;transform: rotate(360deg);}
            }

            `;

            styleElement.appendChild(document.createTextNode(customCSS));

            // Append the style element to the custom footer container
            footerContainer.appendChild(styleElement);

            const generatedHTML = node.outerHTML;
            // Log or use the 'generatedHTML' as needed
            console.log("generatedHTML", generatedHTML);

            const formData = new FormData();
            formData.append("html", generatedHTML); // 'pdfFile' is the name of the file field on the server
            const responseUploadPdf = uploadHtmlCertificate(formData);
             //if (header) {
               // header.parentNode.removeChild(header);
            //}
           //  if (footer) {
             //   footer.parentNode.removeChild(footer);
            //}
            console.log(
                "Certificate  uploaded successfully:",
                responseUploadPdf
            ); */
        });
    };
    const uploadHtmlCertificate = (formData) => {
        auth.postRequest(
            `${LOCATION.ASSESSMENTS.API.path}/upload-html-for-pdf-certificate`,
            formData,
            { timeout: 100000 }
        ) // Updated endpoint
            .then((response) => {
                console.log(" Response ", response);
                let responseData = response.data;
                let mainPdfFile = responseData.data.certificate_pdf;
                let mainPdfFileUrl = responseData.data.certificate_pdf_url;
                setLoadingOverlay(false);
            })
            .catch((error) => {
                // Handle error
            });
    };
    const loadMultiplePages = async (doc) => {
        let footerText = "Powered by FRA Wizard.";
        if (params.pdfWatermark) {
            if (params.pdfWatermark.banner !== "") {
                accreditationLogo = params.pdfWatermark.banner;
            }
            if (params.pdfWatermark.title !== "") {
                footerText = "Powered by " + params.pdfWatermark.title;
            }
        }
        var htmlElement = document.getElementById(element);
        let newParagraph = "";
        if (auth.user && auth.user.admin === true) {
            const classDiv = document.querySelector(".card-body");
            // Create a new <p> element
            newParagraph = document.createElement("p");
            newParagraph.innerHTML =
                '<div class="my-4 fw-bold"><h5>Comment By Admin</h5><div class="my-2 py-2"><h6 class="my-2 ">' +
                params.adminComment +
                "</h6></div></div>";
            // Append the new <p> element to the end of the "classDiv" element
            classDiv.appendChild(newParagraph);
        }
        // Create custom header element
        const customHeader = document.createElement("div");
        customHeader.id = "custom-header";
        customHeader.style.backgroundImage = "url('" + accreditationLogo + "')";
        customHeader.style.backgroundSize = "100% auto";
        customHeader.style.backgroundRepeat = "no-repeat";
        customHeader.style.width = "105%";
        customHeader.style.height = "200px";
        // customHeader.style.backgroundPosition = "0px -5px"; // customize header background color
        customHeader.style.marginTop = "0px";
        customHeader.style.marginLeft = "-12px";
        customHeader.style.marginRight = "-30px";
        customHeader.style.fontFamily = "arial,sans-serif";

        // Create custom footer element
        const customFooter = document.createElement("div");
        customFooter.id = "custom-footer";
        customFooter.style.textAlign = "center";
        customFooter.style.backgroundColor = "#cfd4da"; // customize footer background color
        customFooter.style.width = "105%";
        customFooter.style.height = "50px"; // adjust height as needed
        customFooter.style.paddingTop = "20px";
        // customFooter.style.fontFamily = "arial,sans-serif";
        customFooter.style.marginLeft = "-15px";
        customFooter.style.marginRight = "-30px";
        customFooter.style.color = "#000";
        customFooter.innerText = footerText; //"Powered by FRA Wizard."; // replace with your footer content

        // Append custom header and footer
        //htmlElement.insertBefore(customHeader, htmlElement.firstChild);
        //htmlElement.appendChild(customFooter);

        try {
            // Use html2canvas to capture the entire HTML content

            //var htmlElement = element;//document.getElementById(element);
            // you need to load html2canvas (and dompurify if you pass a string to html)
            setLoadingOverlay(true);
            const opt = {
                callback: function (jsPDF) {
                    //jsPDF.save(fileName);
                    // to open the generated PDF in browser window
                    // window.open(jsPDF.output('bloburl'));

                    const pdfListJSON = getCookie("pdfList");
                    //const pdfListJSON = getCookie("pdfListOnlyPath");
                    let pdfList = [];
                    //let isUploadReportPDF = false;

                    pdfList = JSON.parse(pdfListJSON);
                    //console.log("PdfList from cookie:", pdfList);

                    /* jsPDF.addPage();
                    jsPDF.text(15, 15, "ABC.pdf");
                    jsPDF.addPage();
                    jsPDF.text(15, 15, "XYZ.pdf"); */
                    /* var pdfContentAsDataUrl = doc.output("datauristring");

                    // Display the PDF in an iframe
                    var iframe = document.createElement("iframe");
                    iframe.src = pdfContentAsDataUrl;
                    iframe.style.width = "100%"; // Adjust the width as needed
                    iframe.style.height = "600px"; // Adjust the height as needed */

                    //window.open(htmlContentAsDataUrl);
                    /* if (pdfListJSON) {
                        pdfList = JSON.parse(pdfListJSON);
                        if (pdfList.length > 0) {
                            //isUploadReportPDF = true;
                            console.log("PdfList from cookie:", pdfList);
                            pdfList.forEach((pdfData) => {
                                const pdfName = getPdfName(pdfData);
                                const wrappedPdfName = `{${pdfName}}`;
                                jsPDF.addPage();
                                jsPDF.text(15, 15, wrappedPdfName);
                            });
                            //jsPDF.save(fileName);
                            const blob = jsPDF.output("blob");
                            const formData = new FormData();
                            formData.append("pdf_file", blob, fileName); // 'pdfFile' is the name of the file field on the server
                            formData.append("id", params.id);
                            formData.append("pdf_file_name", pdfList);

                            // Make an HTTP POST request to your server to upload the PDF
                            const responseUploadPdf = uploadPDF(formData);
                            console.log(
                                "PDF uploaded successfully:",
                                responseUploadPdf
                            );
                        } else {
                            //  pdf.save(fileName);
                            jsPDF.save(fileName);
                        }
                    } else {
                        // pdf.save(fileName);
                        jsPDF.save(fileName);
                    } */

                    if (pdfListJSON) {
                        pdfList = JSON.parse(pdfListJSON);
                        if (Object.keys(pdfList).length) {
                            //if (pdfList.length > 0) {
                            //isUploadReportPDF = true;
                            const sdName = getCookie("sdName");
                            var divSd = document.createElement("div");
                            //divSd.className = "page-break add-pdf";
                            //divSd.innerHTML = "<h3> " + sdName + " </h3>";
                            var htmlSD =
                                '<div class="divBreak"></div><table class="table table-bordered"> <thead> <tr><th colspan="2" class="title-bg"><h5 class="m-0" style="font-family: Arial, sans-serif"><h5>' +
                                sdName +
                                "</h5></th></tr></thead>" +
                                "<tbody>" +
                                '<tr> <td colspan="2" class="w-100 bg-tabel-details height-border">' +
                                '<p> The "supporting documentation" section is where you will find additional informative PDF guides designed to bolster and complement your fire risk assessment. These guides serve as valuable resources to aid in your understanding of fire risks and provide essential support to the recommendations section of the assessment.</p> ' +
                                "<p>These PDF guides can be helpful: </p>" +
                                '<div class="sd-div"><strong>Enhanced Understanding </strong>: These guides are crafted to offer in-depth insights into various aspects of fire risks. They can clarify complex concepts, terminology, or scenarios related to fire safety, ensuring you have a comprehensive grasp of the issues.</div>' +
                                '<div class="sd-div"><strong>Practical Guidance</strong>: The guides typically offer information on addressing specific fire risks. They may include actionable advice on fire prevention, emergency response, and safety protocols, enabling you to implement effective measures confidently.</div>' +
                                '<div class="sd-div"><strong>Compliance and Best Practices</strong>: These guides align with fire safety regulations, standards, and best practices. By referencing these guides, you can ensure that your fire risk assessment and subsequent actions align with established safety guidelines.</div>' +
                                '<div class="sd-div"><strong>Support for Recommendations</strong>: When you encounter recommendations within the assessment, these PDF guides can provide supplementary information and strategies for carrying out those recommendations effectively. They act as a valuable toolkit for risk mitigation. </div>' +
                                '<div class="sd-div"><strong>Education and Training</strong>:  Besides aiding in assessments, these guides can serve as educational resources. They can be used for training personnel, employees, or residents on fire safety protocols and procedures.</div>' +
                                '<p> Overall, including these PDF guides in the "supporting documentation" section underscores the commitment to providing you with the necessary tools and knowledge to address fire risks comprehensively and proactively. They are a vital resource to ensure the safety and well-being of your premises and occupants.</p>' +
                                "</td>" +
                                "</tr>" +
                                "</tbody>" +
                                "</table>";
                            divSd.innerHTML = htmlSD;
                            htmlElement.appendChild(divSd);
                            for (const pdfId in pdfList) {
                                if (pdfList.hasOwnProperty(pdfId)) {
                                    const pdfData = pdfList[pdfId];
                                    const pdfName = getPdfName(pdfData.path);
                                    const pdfTitle = pdfData.name;
                                    const wrappedPdfName = `{${pdfName}}`;

                                    console.log(
                                        "PDF Path: ",
                                        pdfName,
                                        wrappedPdfName
                                    );
                                    console.log("PDF Name: ", pdfTitle);

                                    jsPDF.addPage();
                                    jsPDF.text(15, 15, wrappedPdfName);
                                    /* var div = document.createElement("div");
                                    div.className = "page-break add-pdf";
                                    // let docTitle = '<h5>'+pdfData+'</h5>';
                                    div.innerHTML = "<h3>" + pdfTitle + "</h3>";
                                    htmlElement.appendChild(div); */

                                    var divRepalce =
                                        document.createElement("div");
                                    divRepalce.className = "page-break add-pdf";
                                    divRepalce.textContent = wrappedPdfName;
                                    htmlElement.appendChild(divRepalce);

                                    var pageBreakDiv =
                                        document.createElement("div");
                                    pageBreakDiv.style.pageBreakBefore =
                                        "always";
                                    htmlElement.appendChild(pageBreakDiv);
                                }
                            }
                            /*  pdfList.forEach((pdfData) => {
                                const pdfName = getPdfName(pdfData);
                                const wrappedPdfName = `{${pdfName}}`;
                                jsPDF.addPage();
                                jsPDF.text(15, 15, wrappedPdfName);
                                //htmlElement += '<div class="page-break" style="page-break-before: always;">'+wrappedPdfName+' <p>This content should start on a new page.</p>';
                                var div = document.createElement("div");
                                div.className = "page-break add-pdf";
                                // let docTitle = '<h5>'+pdfData+'</h5>';
                                div.textContent = wrappedPdfName;
                                htmlElement.appendChild(div);
                                var pageBreakDiv =
                                    document.createElement("div");
                                pageBreakDiv.style.pageBreakBefore = "always";
                                htmlElement.appendChild(pageBreakDiv);
                            }); */
                        } else {
                            //      jsPDF.save(fileName);
                        }
                    } else {
                        //jsPDF.save(fileName);
                    }
                    //console.log("out ");setLoadingOverlay(false);return false;
                    const htmlContent = htmlElement.outerHTML;
                    const formData = new FormData();
                    //htmlContent = '';
                    formData.append("html", htmlContent); // 'pdfFile' is the name of the file field on the server
                    formData.append("assessment_id", params.id);
                    const responseUploadPdf = uploadHtml(formData);
                    console.log(
                        "HTML  uploaded successfully:",
                        responseUploadPdf
                    );
                },
                margin: [0, 0, 0, 0],
                autoPaging: "text",
                html2canvas: {
                    allowTaint: true,
                    dpi: 300,
                    letterRendering: true,
                    logging: false,
                    scale: scale ?? 1,
                },
            };
            doc.html(htmlElement, opt);
            /* setTimeout(function () {
                doc.html(htmlElement, opt);
            }, 1000); */
            return true;

            /* const canvas = await html2canvas(htmlElement);

            // Convert canvas to PDF using jsPDF
            const pdf = new jsPDF("p", "mm", "a4");
            const imgData = canvas.toDataURL("image/jpeg", 1.0);
            pdf.addImage(imgData, "JPEG", 0, 0, 210, 297); // Adjust width and height as needed

            pdf.save(fileName); */
            //const pdf = loadMultiplePages_v3(doc,htmlElement);
            /* const pdf = new jsPDF("p", "mm", "a4");
            // Original content dimensions
            const originalWidth = 160; // Example width in mm
            const originalHeight = 120; // Example height in mm
            // Calculate aspect ratio
            const aspectRatio = originalWidth / originalHeight;
            // Set the desired width (e.g., 100mm) and calculate the corresponding height
            const desiredWidth = 100;
            const desiredHeight = desiredWidth / aspectRatio;
            // Capture the image with the adjusted dimensions
            const imgData = canvas.toDataURL("image/jpeg", 1.0);
            // Add the image to the PDF with the adjusted dimensions
            pdf.addImage(imgData, "JPEG", 0, 0, desiredWidth, desiredHeight); */

            // Save or display the PDF

            /*
            const pdfListJSON = getCookie("pdfList");
            let pdfList = [];
            let isUploadReportPDF = false;
             if (pdfListJSON) {
                pdfList = JSON.parse(pdfListJSON);
                if (pdfList.length > 0) {
                    isUploadReportPDF = true;
                    console.log("PdfList from cookie:", pdfList);

                    pdfList.forEach((pdfData) => {
                        const pdfName = getPdfName(pdfData);
                        const wrappedPdfName = `{${pdfName}}`;
                        pdf.addPage();
                        pdf.text(15, 15, wrappedPdfName);
                    });

                    const blob = pdf.output("blob");
                    const formData = new FormData();
                    formData.append("pdf_file", blob, fileName); // 'pdfFile' is the name of the file field on the server
                    formData.append("id", params.id);
                    formData.append("pdf_file_name", pdfList);

                    // Make an HTTP POST request to your server to upload the PDF
                    const responseUploadPdf = uploadPDF(formData);
                    console.log(
                        "PDF uploaded successfully:",
                        responseUploadPdf
                    );
                } else {
                    //  pdf.save(fileName);
                }
            } else {
                // pdf.save(fileName);
            } */

            /* const response = await axios.post("your-server-api-url", formData, {
                headers: {
                    "Content-Type": "multipart/form-data", // Make sure to set the content type to 'multipart/form-data'
                },
            }); */

            // Handle the server response here
        } catch (error) {
            console.error("Error generating PDF:", error);
        }

        // Remove custom header and footer after generating the PDF
        if (customHeader) {
            customHeader.parentNode.removeChild(customHeader);
        }
        if (customFooter) {
            customFooter.parentNode.removeChild(customFooter);
        }
        if (newParagraph) {
            newParagraph.parentNode.removeChild(newParagraph);
        }
    };
    const uploadHtml = (formData) => {
        /* formData.append(
            "lv_token",
            "e72304b57efb600137c863578844cbfbbb53aca299661f015c3db9ce2821854c"
        );
        auth.postRequest(
            `https://firesafety.project.frawizard.co.uk/api/pdf_from_html`,
            formData,
            { timeout: 100000 }
        )
            .then((response) => {
                console.log(" Response ", response);
                let responseData = response.data;
                let mainPdfFile = responseData.data.main_pdf;
                let mainPdfFileUrl = responseData.data.main_pdf_url;
                const pdfListJSON = getCookie("pdfList");
                let pdfList = [];
                if (pdfListJSON) {
                    pdfList = JSON.parse(pdfListJSON);
                    if (pdfList.length > 0) {
                        pdfList = JSON.parse(pdfListJSON);
                        const formDataPdf = new FormData();
                        formDataPdf.append("main_pdf", mainPdfFile);
                        formDataPdf.append("id", params.id);
                        formDataPdf.append("pdf_file_name", pdfList);
                        const responseUploadPdf = doMergePdf(formDataPdf);
                        console.log(
                            " uploadHtml response ",
                            responseUploadPdf,
                            formDataPdf
                        );
                    } else {
                        window.location.href = mainPdfFileUrl;
                        setLoadingOverlay(false);
                    }
                } else {
                    window.location.href = mainPdfFileUrl;
                    setLoadingOverlay(false);
                }
            })
            .catch((error) => {
                // Handle error
            });

        return false; */
        auth.postRequest(
            `${LOCATION.ASSESSMENTS.API.path}/upload-html-for-pdf`,
            formData,
            { timeout: 100000 }
        ) // Updated endpoint
            .then((response) => {
                console.log(" Response ", response);
                let responseData = response.data;
                let mainPdfFile = responseData.data.main_pdf;
                let mainPdfFileUrl = responseData.data.main_pdf_url;
                const pdfListJSON = getCookie("pdfListOnlyPath");
                let pdfList = [];
                if (pdfListJSON) {
                    pdfList = JSON.parse(pdfListJSON);
                    if (pdfList.length > 0) {
                        //pdfList = JSON.parse(pdfListJSON);
                        const formDataPdf = new FormData();
                        formDataPdf.append("main_pdf", mainPdfFile);
                        formDataPdf.append("id", params.id);
                        formDataPdf.append("pdf_file_name", pdfList);
                        const responseUploadPdf = doMergePdf(formDataPdf);
                        console.log(
                            " uploadHtml response ",
                            responseUploadPdf,
                            formDataPdf
                        );
                    } else {
                        window.location.href = mainPdfFileUrl;
                        setLoadingOverlay(false);
                    }
                } else {
                    window.location.href = mainPdfFileUrl;
                    setLoadingOverlay(false);
                }
            })
            .catch((error) => {
                // Handle error
            });
    };
    const doMergePdf = (formData) => {
        //let pdfData = pdfFile.target.files[0];
        //let form = new FormData();
        //form.append("image", pdfData); // Updated field name

        auth.postRequest(
            `${LOCATION.ASSESSMENTS.API.path}/upload-pdf-for-report-v`,
            formData
        ) // Updated endpoint
            .then((response) => {
                //setPdfUrl(response.data); // Updated state variable name
                console.log(" domerg ", response);
                setLoadingOverlay(false);
                window.location.href = response.data;
                /* let fileUrl = response.data;
                fetch(fileUrl)
                    .then((response) => response.blob())
                    .then((blob) => {
                        // Create a URL for the blob data
                        const blobUrl = URL.createObjectURL(blob);

                        // Create an invisible anchor element
                        const anchor = document.createElement("a");
                        anchor.style.display = "none";
                        document.body.appendChild(anchor);

                        const timestamp = Date.now();
                        const filename = `report_${timestamp}.pdf`;
                        // Set the anchor's href to the blob URL and add the download attribute
                        anchor.href = blobUrl;
                        //anchor.download = filename;
                        anchor.target = "_blank";

                        // Trigger a click event on the anchor to initiate the download
                        anchor.click();

                        // Clean up by revoking the blob URL and removing the anchor element
                        URL.revokeObjectURL(blobUrl);
                        document.body.removeChild(anchor);
                    })
                    .catch((error) => {
                        console.error("Error downloading the file:", error);
                    }); */
            })
            .catch((error) => {
                // Handle error
            });
    };
    const uploadPDF = (formData) => {
        //let pdfData = pdfFile.target.files[0];
        //let form = new FormData();
        //form.append("image", pdfData); // Updated field name

        auth.postRequest(
            `${LOCATION.ASSESSMENTS.API.path}/upload-pdf-for-report`,
            formData
        ) // Updated endpoint
            .then((response) => {
                //setPdfUrl(response.data); // Updated state variable name
                window.location.href = response.data;
                /* let fileUrl = response.data;
                fetch(fileUrl)
                    .then((response) => response.blob())
                    .then((blob) => {
                        // Create a URL for the blob data
                        const blobUrl = URL.createObjectURL(blob);

                        // Create an invisible anchor element
                        const anchor = document.createElement("a");
                        anchor.style.display = "none";
                        document.body.appendChild(anchor);

                        const timestamp = Date.now();
                        const filename = `report_${timestamp}.pdf`;
                        // Set the anchor's href to the blob URL and add the download attribute
                        anchor.href = blobUrl;
                        //anchor.download = filename;
                        anchor.target = "_blank";

                        // Trigger a click event on the anchor to initiate the download
                        anchor.click();

                        // Clean up by revoking the blob URL and removing the anchor element
                        URL.revokeObjectURL(blobUrl);
                        document.body.removeChild(anchor);
                    })
                    .catch((error) => {
                        console.error("Error downloading the file:", error);
                    }); */
            })
            .catch((error) => {
                // Handle error
            });
    };
    const getPdfName = (path) => {
        const inputString = path;
        console.log(" inputString ", inputString);
        if (inputString != "" && inputString != null) {
            // Use a regular expression to match the desired pattern
            const match = inputString.match(/\/([^/.]+)\.pdf$/);

            // Extract the matched value (the part between the last "/" and ".pdf")
            const extractedValue = match ? match[1] : null;

            return extractedValue + ".pdf";
        } else {
            return "";
        }
    };
    const getCookie = (name) => {
        const cookieName = `${name}=`;
        const cookies = document.cookie.split(";");
        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i];
            while (cookie.charAt(0) === " ") {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(cookieName) === 0) {
                return cookie.substring(cookieName.length, cookie.length);
            }
        }
        return null;
    };

    const loadMultiplePages_v3 = (doc, element) => {
        var htmlElement = element; //document.getElementById(element);
        // you need to load html2canvas (and dompurify if you pass a string to html)
        const opt = {
            callback: function (jsPDF) {
                jsPDF.save(fileName);
                // to open the generated PDF in browser window
                // window.open(jsPDF.output('bloburl'));
            },
            margin: [0, 0, 0, 0],
            autoPaging: "text",
            html2canvas: {
                allowTaint: true,
                dpi: 300,
                letterRendering: true,
                logging: false,
                scale: scale ?? 1,
            },
        };
        doc.html(htmlElement, opt);
    };

    const loadMultiplePages_bk = (doc) => {
        var htmlElement = document.getElementById(element);
        // you need to load html2canvas (and dompurify if you pass a string to html)
        const opt = {
            callback: function (jsPDF) {
                jsPDF.save(fileName);
                // to open the generated PDF in browser window
                // window.open(jsPDF.output('bloburl'));
            },
            margin: [0, 0, 0, 0],
            autoPaging: "text",
            html2canvas: {
                allowTaint: true,
                dpi: 300,
                letterRendering: true,
                logging: false,
                scale: scale ?? 1,
            },
        };
        doc.html(htmlElement, opt);
    };
    if (loadingOverlay) {
        return <LoaderOverlay />;
    }
    return (
        <>
            <Button
                variant="light"
                size="sm"
                className="text-primary"
                onClick={() => downloadPDF()}
            >
                <span className="me-1">{t("common.download")}</span>
                <Download />
            </Button>
        </>
    );
}

export default DownloadButton;
